module.exports = __webpack_public_path__ + "img/9788952210654.a06a2ae8.jpg";